export default __webpack_public_path__ + "static/media/ARA_2x.0bb2ea31.png";